import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { UploadCloud as IconUpload } from 'lucide-react';
import React from 'react';
import ReactDropzone, { DropzoneProps } from 'react-dropzone';

type Props = {
  label?: string;
  activeLabel?: string;
  errorLabel?: string;
  note?: string;
  onDrop: DropzoneProps['onDrop'];
  error?: boolean;
  active?: boolean;
  height?: React.CSSProperties['height'];
};

const Container = styled('div')<{
  error?: boolean;
  active?: boolean;
  height?: React.CSSProperties['height'];
}>((p) => {
  const strokeColor = p.active
    ? p.theme.custom.colors.green.w400
    : p.error
    ? p.theme.custom.colors.red.w300
    : p.theme.custom.colors.gray.w300;
  const strokeStyle = p.active ? 'dashed' : 'solid';
  const fgColor = p.active
    ? p.theme.custom.colors.green.w500
    : p.error
    ? p.theme.custom.colors.red.w500
    : p.theme.custom.colors.gray.w500;
  const bgColor = p.active
    ? p.theme.custom.colors.green.w100
    : p.error
    ? p.theme.custom.colors.red.w100
    : p.theme.custom.colors.gray.w100;
  return {
    width: '100%',
    height: p.height || '200px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px ${strokeStyle} ${strokeColor}`,
    backgroundColor: bgColor,
    borderRadius: p.theme.shape.borderRadius,
    color: fgColor,
    gap: p.theme.spacing(),
    padding: p.theme.spacing(2)
  };
});

export const Dropzone: React.FC<Props> = ({
  label = 'Drag and drop files here or click to select',
  activeLabel = 'Release to upload',
  errorLabel = 'Upload Failed',
  height,
  note = '',
  onDrop,
  error = false
}) => {
  return (
    <ReactDropzone onDrop={onDrop}>
      {({ getRootProps, isDragActive, getInputProps }) => (
        <Container
          {...getRootProps({
            refKey: 'ref',
            isDragActive
          })}
          error={error}
          active={isDragActive}
          height={height}
        >
          <input {...getInputProps()} />
          <IconUpload size={36} />
          <Typography variant="h6">
            {isDragActive ? activeLabel : error ? errorLabel : label}
          </Typography>
          {note && <Typography variant="caption">{note}</Typography>}
        </Container>
      )}
    </ReactDropzone>
  );
};
